@if (providerDataReview) {
  <div class="card mb-2">
    <div class="card-body bg-warning-subtle">
        <div class="row">
          <div class="col-7 pt-2">
            There's an open <strong>{{ humanizedReviewTypeMapping[providerDataReview.type] | uppercase }}</strong> for this provider.
          </div>
          @if (editingAssignedTo) {
            <div class="col-5 text-end">
              <app-provider-data-review-assignments
                [assignedTo]="providerDataReview.assignedTo"
                [showAssignmentsLabel]="false"
                (assignmentUpdate)="onAssignedToUpdate($event)"
                (assignmentCanceled)="onAssignedToCancel()"
              />
            </div>
          } @else {
            <div class="col-5 px-2 text-end">
              <span class="pe-2">Assigned To: {{ providerDataReview.assignedTo?.fullName | blankValueDash }}</span>
              @if (canAssignToProviderDataReview) {
                <a href="javascript:;" (click)="onEditAssignedTo($event)" class="text-secondary"><fa-icon [icon]="['fas', 'pen']" /></a>
              }
            </div>
          }
        </div>
    </div>
  </div>
} @else {
  <div class="card mb-2">
    <div class="card-body">
      There are no open data reviews for this provider.
    </div>
  </div>
}